import ErrorFallback from 'Components/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import {
  MobileOrderDetailPage,
  MobileOrderListPage,
  WalttiPosOrderDetailPage,
  WalttiPosOrderListPage,
  WebShopOrderDetailPage,
  WebShopOrderListPage
} from './Pages'

const OrderRoot = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route path={`webshop-orders`} element={<WebShopOrderListPage />} />
        <Route path={`webshop-orders/:id`} element={<WebShopOrderDetailPage />} />
        <Route path={`mobile-orders`} element={<MobileOrderListPage />} />
        <Route path={`mobile-orders/:id`} element={<MobileOrderDetailPage />} />
        <Route path={`walttipos-orders`} element={<WalttiPosOrderListPage />} />
        <Route path={`walttipos-orders/:id`} element={<WalttiPosOrderDetailPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default OrderRoot
